<template>
  <custom-dialog :title="model.title" :visible="visible" v-on="$listeners" width="800px" class="acceptance-comments-dialog" :appendToBody="true">
    <div class="dialog-body">
      <el-form label-position="top" :model="form" :rules="rules" ref="form">
        <!-- close_standard  标准  close_priority_standard -->
        <el-form-item :label="$t('asm_acceptance_comments_dialog.you_xian_ji')" v-if="priorityVisible" prop="priority">
          <custom-select v-model="form.priority" code="asm_close_priority"></custom-select>
        </el-form-item>
        <el-form-item :label="opinionLabel" prop="opinion" :class="!priorityVisible ? 'is-required' : ''">
          <el-input type="textarea" :rows="6" v-model="form.opinion"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/**
 * 受理意见
 */
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {
    // model: {
    //   data: { // 详情数据
    //  }
    // },
    /**
     * 操作类型
     * 关闭案例：closeCase
     * 受理案例：acceptCase
     * 新增案例意见：addCaseOpinion
     * 编辑案例意见：editCaseOpinion
     * 关闭工单：closeWorkOrder
     */
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        opinion: '',
        priority: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        opinion: {
          validator: (rule, value, callback) => {
            // 如果优先级不在，那么原因是必填项
            if (!this.priorityVisible) {
              if (!value) {
                return callback(new Error(this.$t('Common.com_required')));
              }
            }

            // 校验opinion长度
            if (value) {
              if (value.length > 500) {
                return callback(new Error(this.$t('asm_acceptance_comments_dialog.cdzc500gzf')));
              }
            }

            return callback();
          },
        },
        priority: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required')
        },
      };
    },
    opinionLabel() {
      let ret = '';
      switch (this.type) {
        case 'closeCase':
          ret = this.$t('asm_acceptance_comments_dialog.qu_xiao_yuan_yin');
          break;
        case 'acceptCase':
          ret = this.$t('asm_acceptance_comments_dialog.shou_li_yi_jian');
          break;
        case 'addCaseOpinion':
          ret = this.$t('asm_acceptance_comments_dialog.shou_li_yi_jian');
          break;
        case 'editCaseOpinion':
          ret = this.$t('asm_acceptance_comments_dialog.shou_li_yi_jian');
          break;
        case 'closeWorkOrder':
          ret = this.$t('asm_acceptance_comments_dialog.yuan_yin');
          break;
      }
      return ret;
    },
    // 是否展示优先级下拉框
    /*
     * 受理案例：acceptCase
     * 新增案例意见：addCaseOpinion
     * 编辑案例意见：editCaseOpinion
     */
    priorityVisible() {
      const whilteList = ['acceptCase', 'addCaseOpinion', 'editCaseOpinion'];
      return whilteList.includes(this.type);
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    getReqUrl() {
      let ret = '';
      switch (this.type) {
        case 'closeCase':
          ret = apis.caseOrderUpdateState;
          break;
        case 'acceptCase':
          ret = apis.caseOrderUpdateState;
          break;
        case 'addCaseOpinion':
          ret = apis.caseOrderUpdateServiceRemark;
          break;
        case 'editCaseOpinion':
          ret = apis.caseOrderUpdateServiceRemark;
          break;
        case 'closeWorkOrder':
          ret = apis.WorkOrderOptCloseOrder;
          break;
      }
      return ret;
    },
    getReqData() {
      const data = this.model.data;
      let ret = {};
      if (this.priorityVisible) {
        ret.priority = this.form.priority;
      }
      if (this.type === 'closeCase') {
        ret = Object.assign(ret, {
          caseOrderId: data.caseOrderId,
          caseOrderState: 120,
          orderCloseReason: this.form.opinion,
        });
        return ret;
      }
      if (this.type === 'acceptCase') {
        ret = Object.assign(ret, {
          caseOrderId: data.caseOrderId,
          caseOrderState: 30,
          customerServiceRemark: this.form.opinion,
        });
        return ret;
      }
      if (['addCaseOpinion', 'editCaseOpinion'].includes(this.type)) {
        ret = Object.assign(ret, {
          caseOrderId: data.caseOrderId,
          customerServiceRemark: this.form.opinion,
        });
        return ret;
      }
      ret = Object.assign(ret, {
        workOrderId: data.workOrderId,
        remark: this.form.opinion,
      });
      return ret;
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const reqUrl = this.getReqUrl();
          const reqData = this.getReqData();
          this.$postJSON(reqUrl, reqData, true).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.closeDialog();
            this.$emit('success', this.form.opinion);
          });
        }
      });
    },
    closeDialog() {
      this.visible = false;
    },
    async init() {
      const data = this.model.data || {};
      if (data.priority) {
        this.form.priority = data.priority;
      } else {
        // 默认优先级为标准 todo,这里最好用字典
        this.form.priority = 'close_standard';
      }

      if (data.customerServiceRemark) {
        this.form.opinion = data.customerServiceRemark;
      }
    },
  },
  created() {},
  mounted() {
    this.init();
  },
};
</script>

<style></style>
